import { css } from 'emotion'
// import { LINK_COLOR, LINK_COLOR_DARK  } from 'constants/styleConstants'

export const DescriptionToolBarStyles = css`
  padding: 8px;
`
